import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    //fontFamily: "'Roboto', 'Arial', sans-serif", // Set global font family
    //fontSize: 14, // Base font size (default is 14px)
    //htmlFontSize: 16, // Default browser size
    //fontSize: 12, // Scale all fonts globally (smaller baseline)
    h1: {
      fontSize: "2.5rem", // Example: Heading 1 size
      fontWeight: 700, // Font weight for h1
    },
    h2: {
      fontSize: "2rem", // Heading 2 size
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.75rem", // Heading 3 size
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem", // Heading 4 size
      fontWeight: 600,
    },
    h5: {
      fontSize: "1.25rem", // Heading 5 size
      fontWeight: 600,
    },
    h6: {
      fontSize: "1.125rem", // Heading 6 size
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: "1rem", // Subtitle text
    },
    subtitle2: {
      fontSize: "0.875rem", // Smaller subtitle text
    },      
    body1: {
      fontSize: "1rem", // Default body text
    },
    body2: {
      fontSize: "0.875rem", // Smaller body text
    },
  },
  palette: {
    primary: {
      main: "#556cd6", // Primary color
      light: "rgba(85, 108, 214, 0.5)",
    },
    secondary: {
      main: "#81c784", // Secondary color
      light: "rgba(129, 199, 132, 0.5)",
    },
    text: {
      primary: "#333", // Default text color
    },
    background: {
      default: "#f9f9f9", // Default background color
    },
  },
  breakpoints: {
    values: {
      xs: 0, // Mobile
      sm: 600, // Tablets
      md: 960, // Small desktops
      lg: 1280, // Large desktops
      xl: 1920, // Extra large screens
    },
  },
});

export default theme;
